import { useState, useEffect } from "react";

const Loader = ({ fadeOut = false }) => {
  const [scale, setScale] = useState(1);
  const [hideBackground, setHideBackground] = useState(false);

  useEffect(() => {
    const animationInterval = setInterval(() => {
      setScale((prevScale) => (prevScale === 1 ? 1.1 : 1));
    }, 500);

    return () => clearInterval(animationInterval);
  }, []);

  useEffect(() => {
    if (fadeOut) {
      setTimeout(() => setHideBackground(true), 500); // Delay background fade-out
    }
  }, [fadeOut]);

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center transition-opacity duration-500 ${
        hideBackground ? "opacity-0" : "opacity-100"
      }`}
      style={{ backgroundColor: "#181714" }} // Keep the background fixed
    >
      <img
        src="/img/cajuu.png"
        alt="Cajuu Logo"
        className="w-30 h-30 object-cover transition-opacity duration-500"
        style={{
          transform: `scale(${scale}) rotate(${
            scale === 1.1 ? "5deg" : "0deg"
          })`,
          opacity: fadeOut ? 0 : 1, // Fade out smoothly
          transition: "transform 0.5s ease-in-out, opacity 0.5s ease-in-out",
        }}
      />
    </div>
  );
};

export default Loader;
